export default "<tabbed-modal-tab tab=\"$ctrl.tab\">\r\n\t<entity-users entity=\"$ctrl.entity\">\r\n\t</entity-users>\r\n</tabbed-modal-tab>\r\n";